// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.
import { StoreDevtoolsModule } from '@ngrx/store-devtools';

export const environment = {
  production: true,
  envName: 'aqa',
  get AUTH_API_URI(): string {
      return (window as any).AUTH_API_URI;
  },
  get PASSPORT_API_URI(): string {
      return (window as any).PASSPORT_API_URI;
  },
  get USERS_API_URI(): string {
      return (window as any).USERS_API_URI;
  },
  get versionedConfigUrlTemplate(): string {
      return (window as any).versionedConfigUrlTemplate;
  },
  get CUSTOMERS_API_URI(): string {
      return (window as any).CUSTOMERS_API_URI;
  },
  get USER_IQ_SITE_ID(): string {
      return (window as any).USER_IQ_SITE_ID;
  },
  get SMATH_IMPL_ID(): string {
    return (window as any).SMATH_IMPL_ID;
  },
  CONFIG_FALLBACK_URI: "https://www.qa-cli.com/config",
  CURRICULUM_API_URI: 'https://passport.qa-cli.com/curriculum',
  RUSH_API_URI: 'https://www.qa-cli.com/rush',
  PENDO_API_KEY: "6a4e15af-9048-41b3-764e-6b947be1f2cf", // TODO set to empty once testing complete
};

export const extModules = [
    // StoreDevtoolsModule.instrument()
];
